import { useEffect, useRef } from "react";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import {
  FestivalInterviewBanner,
  FestivalInterviewBannerWrapper,
} from "./style";

const RabbitFestivalInterviewBanner = () => {
  const { setShowHeader, interview } = useRabbitFestivalContext();
  const bannerRef = useRef<HTMLDivElement>(null);

  // header 투명 여부
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setShowHeader(true);
        } else {
          setShowHeader(false);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [bannerRef.current]);

  return (
    <FestivalInterviewBannerWrapper ref={bannerRef}>
      <img src="/image-web/rabbit/interview_back.png" alt="banner" />
      {interview?.mainCoverImageUrl && (
        <FestivalInterviewBanner>
          <img src={interview?.mainCoverImageUrl} alt="user" />
          <div className="rank">
            <img src={`image-web/rabbit/rank1.png`} alt="rank" />
          </div>
        </FestivalInterviewBanner>
      )}
    </FestivalInterviewBannerWrapper>
  );
};

export default RabbitFestivalInterviewBanner;
